import { useState, useCallback, useEffect } from 'react';
import { getKbGroupId, setKbGroupId, KB_GROUP_ID_CHANGE_EVENT } from '../utils/kbGroupId';

/**
 * Shared selected group for Analytics / People / KB (synced via session + event).
 */
export function useAnalyticsGroupId() {
  const [selectedGroupId, setSelectedGroupId] = useState(() => getKbGroupId());

  useEffect(() => {
    const onChange = (e) => {
      const id = e?.detail ?? null;
      setSelectedGroupId((prev) => (prev === id ? prev : id));
    };
    window.addEventListener(KB_GROUP_ID_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(KB_GROUP_ID_CHANGE_EVENT, onChange);
  }, []);

  const handleGroupSelect = useCallback((groupId) => {
    if (!groupId || groupId === selectedGroupId) return;
    setKbGroupId(groupId);
    setSelectedGroupId(groupId);
  }, [selectedGroupId]);

  const syncGroupId = useCallback((groupId) => {
    if (!groupId) return;
    setKbGroupId(groupId);
    setSelectedGroupId(groupId);
  }, []);

  return {
    selectedGroupId,
    setSelectedGroupId: handleGroupSelect,
    syncGroupId,
  };
}
